module.exports = __webpack_public_path__ + "img/yield.a61384f7.png";